/* Curated seed inventory. Every record is "Live & Available" and carries the
   Aditi Certified Title Check — this is the editorial standard, not a flag we toggle. */

export const ASSET_CLASSES = ["Apartments", "Villas", "Houses", "Plots", "Land"];

export const properties = [
  {
    id: "the-obsidian-residences",
    title: "The Obsidian Residences",
    assetClass: "Apartments",
    locality: "Jubilee Hills",
    city: "Hyderabad",
    price: 48500000,
    priceLabel: "₹4.85 Cr",
    beds: 4, baths: 5, area: 3850, areaUnit: "sq.ft",
    verifiedDays: 2,
    tone: ["#1a1c22", "#2c2f3a"],
    accent: "#D4AF37",
    blurb:
      "A half-floor sky residence with private lift lobby, imported stone, and a 60-ft cantilevered terrace overlooking the city's greenest ridge.",
    highlights: ["Private lift lobby", "Italian marble", "Smart-home wired", "2 covered car bays"],
    construction: false,
  },
  {
    id: "casa-meridian",
    title: "Casa Meridian",
    assetClass: "Villas",
    locality: "ECR",
    city: "Chennai",
    price: 71000000,
    priceLabel: "₹7.10 Cr",
    beds: 5, baths: 6, area: 6200, areaUnit: "sq.ft",
    verifiedDays: 1,
    tone: ["#20251f", "#39402f"],
    accent: "#D4AF37",
    blurb:
      "A sea-facing courtyard villa designed around light and breeze — infinity edge pool, double-height living, and a teak-lined study.",
    highlights: ["Sea-facing", "Infinity pool", "Home theatre", "Solar + grid"],
    construction: false,
  },
  {
    id: "the-walnut-house",
    title: "The Walnut House",
    assetClass: "Houses",
    locality: "Indiranagar",
    city: "Bengaluru",
    price: 39500000,
    priceLabel: "₹3.95 Cr",
    beds: 4, baths: 4, area: 3200, areaUnit: "sq.ft",
    verifiedDays: 4,
    tone: ["#241d18", "#3d2f24"],
    accent: "#D4AF37",
    blurb:
      "An independent house on a quiet leaf-lined street — warm, restrained, and move-in ready, with a landscaped rear garden.",
    highlights: ["Independent plot", "North-east facing", "Garden + deck", "Vaastu-aligned"],
    construction: false,
  },
  {
    id: "amaravati-greens-plot",
    title: "Amaravati Greens — Estate Plot",
    assetClass: "Plots",
    locality: "Amaravati",
    city: "Andhra Pradesh",
    price: 18500000,
    priceLabel: "₹1.85 Cr",
    beds: null, baths: null, area: 4356, areaUnit: "sq.ft",
    verifiedDays: 3,
    tone: ["#1b211c", "#2f3a30"],
    accent: "#D4AF37",
    blurb:
      "A gated estate plot in a master-planned corridor — clear marketable title, fenced, with road, drainage, and underground utilities laid.",
    highlights: ["Gated layout", "Clear title", "Corner plot", "Build-ready"],
    construction: true,
  },
  {
    id: "kanha-agri-belt",
    title: "Kanha Agri-Belt Parcel",
    assetClass: "Land",
    locality: "Devanahalli Belt",
    city: "Bengaluru Rural",
    price: 62000000,
    priceLabel: "₹6.20 Cr",
    beds: null, baths: null, area: 5.2, areaUnit: "acres",
    verifiedDays: 6,
    tone: ["#1e2118", "#39402a"],
    accent: "#D4AF37",
    blurb:
      "Five-plus contiguous acres along a fast-appreciating airport corridor — converted, fenced, with water table tested and survey reconciled.",
    highlights: ["NA-converted", "Road frontage", "Water assured", "Survey reconciled"],
    construction: true,
  },
  {
    id: "the-ivory-penthouse",
    title: "The Ivory Penthouse",
    assetClass: "Apartments",
    locality: "Worli",
    city: "Mumbai",
    price: 245000000,
    priceLabel: "₹24.5 Cr",
    beds: 4, baths: 5, area: 5100, areaUnit: "sq.ft",
    verifiedDays: 1,
    tone: ["#181a1f", "#2a2d36"],
    accent: "#D4AF37",
    blurb:
      "A duplex penthouse on the sea-link with a private plunge pool, sky-deck, and uninterrupted Arabian Sea frontage.",
    highlights: ["Duplex sky-deck", "Private pool", "Sea-link view", "Concierge floor"],
    construction: false,
  },
];

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n);

export const getProperty = (id) => properties.find((p) => p.id === id);
